'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Join several class names together
 *
 * @param classNames classnames to join
 * @returns classnames concatenated
 */
var useCombinedClassName = function useCombinedClassName() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(function (x) {
    return x;
  }).join(' ');
};

exports.useCombinedClassName = useCombinedClassName;
//# sourceMappingURL=index.js.map
